/* eslint-disable jsx-a11y/anchor-is-valid */
import { useState } from 'react'
import { useDispatch } from 'react-redux'
import * as Yup from 'yup'
import clsx from 'clsx'
import { useFormik } from 'formik'
import * as auth from '../redux/AuthRedux'
import { login } from '../redux/AuthCRUD'
import { Link } from 'react-router-dom'

const loginSchema = Yup.object().shape({
  username: Yup.string().required('Username is required'),
  password: Yup.string().required('Password is required'),
})

const initialValues = {
  username: '',
  password: '',
}

/*
  Formik+YUP+Typescript:
  https://jaredpalmer.com/formik/docs/tutorial#getfieldprops
  https://medium.com/@maurice.de.beijer/yup-validation-and-typescript-and-formik-6c342578a20e
*/

export function Login() {
  const [capsLockOn, setCapsLockOn] = useState(false);
  const [loading, setLoading] = useState(false)
  const [showPassword, setShowPassword] = useState(false); const dispatch = useDispatch()

  const formik = useFormik({
    initialValues,
    validationSchema: loginSchema,
    onSubmit: (values, { setStatus, setSubmitting }) => {
      setLoading(true)
      setTimeout(() => {
        login(values.username, values.password)
          .then(({ data }) => {
            setLoading(false)
            if (data.Response.Token) {
              if (process.env.REACT_APP_MAINTENANCE_MODE == 'true') {
                localStorage.setItem('maintenanceMode', 'true')
              }
              localStorage.setItem('k', btoa(data.Response.Token))
              localStorage.setItem('p', btoa(JSON.stringify(data.Response.UserType)))
            }
            dispatch(auth.actions.login(data));
            dispatch(auth.actions.setUser(data.Response))
          })
          .catch(() => {
            setLoading(false)
            setSubmitting(false)
            setStatus('The login detail is incorrect')
          })
      }, 1000)
    },
  })

  const checkCapslockStatus = (event: any) => {
    setCapsLockOn(event.getModifierState("CapsLock"));
  };

  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };


  return (
    <form
      className='form w-100'
      onSubmit={formik.handleSubmit}
      noValidate
      id='kt_login_signin_form'
    >
      {/* begin::Heading */}
      <div className='text-center mb-10'>
        <h1 className='text-dark mb-3'>Sign in to iToplight cloud</h1>
      </div>
      {/* begin::Heading */}

      {formik.status && (
        <div className='mb-lg-15 alert alert-danger'>
          <div className='alert-text font-weight-bold'>{formik.status}</div>
        </div>
      )}

      {/* begin::Form group */}
      <div className='fv-row mb-10'>
        <label className='form-label fs-6 fw-bolder text-dark'>Username</label>
        <input
          placeholder='Username'
          {...formik.getFieldProps('username')}
          className={clsx(
            'form-control form-control-lg form-control-solid',
            { 'is-invalid': formik.touched.username && formik.errors.username },
            {
              'is-valid': formik.touched.username && !formik.errors.username,
            }
          )}
          name='username'
          autoComplete='off'
        />
        {formik.touched.username && formik.errors.username && (
          <div className='fv-plugins-message-container'>
            <span className='text text-danger' role='alert'>
              {formik.errors.username}
            </span>
          </div>
        )}
      </div>
      {/* end::Form group */}

      {/* begin::Form group */}
      <div className='fv-row mb-10'>
        <div className='d-flex justify-content-between mt-n5'>
          <div className='d-flex flex-stack mb-2'>
            {/* begin::Label */}
            <label className='form-label fw-bolder text-dark fs-6 mb-0'>Password</label>
            {/* end::Label */}
            {/* begin::Link */}
            {/* <Link
              to='/auth/forgot-password'
              className='link-primary fs-6 fw-bolder'
              style={{ marginLeft: '5px' }}
            >
              Forgot Password ?
            </Link> */}
            {/* end::Link */}
          </div>
        </div>

        <div className="d-flex flex-column gap-2">
          <div className="position-relative">
            <input
              type={showPassword ? "text" : "password"}
              autoComplete='off'
              {...formik.getFieldProps('password')}
              className={clsx(
                'form-control form-control-lg form-control-solid',
                // {
                //   'is-invalid': formik.touched.password && formik.errors.password,
                // },
                // {
                //   'is-valid': formik.touched.password && !formik.errors.password,
                // }
              )}
              onKeyDown={checkCapslockStatus}
            />
            <button
              type="button"
              className="btn btn-link position-absolute top-50 end-0 translate-middle-y me-3"
              onClick={togglePasswordVisibility}
            >
              {showPassword ? <i className="text-dark fs-4 fa fa-eye-slash"></i> : <i className="text-dark fs-4 fa fa-eye"></i>}
            </button>
          </div>
          <div className="d-flex flex-column">
            {formik.touched.password && formik.errors.password && (
              <div className='fv-plugins-message-container'>
                <div className='fv-help-block'>
                  <span className='text text-danger' role='alert'>
                    {formik.errors.password}
                  </span>
                </div>
              </div>
            )}
            {capsLockOn && (
              <div className="d-flex align-items-center gap-2 text-muted">
                {/* <i className="fs-5 bi bi-exclamation-circle"></i> */}
                Caps lock is activated
              </div>
            )}
          </div>
        </div>
      </div>
      {/* end::Form group */}

      {/* begin::Action */}
      <div className='text-center'>
        <button
          type='submit'
          id='kt_sign_in_submit'
          className='btn btn-lg btn-primary w-100 mb-5'
          disabled={formik.isSubmitting || !formik.isValid}
        >
          {!loading && <span className='indicator-label'>Continue</span>}
          {loading && (
            <span className='indicator-progress' style={{ display: 'block' }}>
              Please wait...
              <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
            </span>
          )}
        </button>

        {/* end::Google link */}
      </div>
      {/* end::Action */}

      <div className='fv-row'>
        <div className='flex-stack text-end'>
          {/* begin::Link */}
          <Link
            to='/auth/forgot-password'
            className='link-primary fs-6'
            style={{ marginLeft: '5px' }}
            reloadDocument
          >
            Forgot Password ?
          </Link>
          {/* end::Link */}
        </div>
      </div>
    </form>
  )
}
